import { useMemo } from 'react';
import { useSelector } from 'react-redux';

// Hook: useGovtIdVerification
// Purpose: Centralize government ID verification checks.
// Usage:
// const { isUploaded, isVerified, isComplete, canInteract, message, check } = useGovtIdVerification();
// if (!canInteract) { /* block action and show message */ }

export default function useGovtIdVerification() {
  const userDetails = useSelector((state) => state.userDetails?.userDetails);

  const result = useMemo(() => {
    const govt = userDetails?.governmentId ?? null;

    console.log('useGovtIdVerification - govt:', govt);
    // Only presence of a governmentId matters for interaction (per new requirement)
    const isUploaded = govt !== null && typeof govt === 'object' && (govt.id || govt.fileUrl || govt.uploadedOn);
    const isVerified = !!(govt && (govt.isVerified === true || String(govt.verificationStatus).toLowerCase() === 'approved'));
    // Per request: treat any uploaded gov id (even pending) as sufficient
    const isComplete = Boolean(isUploaded);

    // A convenience flag that consumers should check before allowing vote/like/comment
    const canInteract = Boolean(isComplete);

    const message = isUploaded
      ? 'Your Government ID was uploaded. Please check the Amalgamate mobile app for verification status.'
      : 'Please verify your Government ID using the Amalgamate mobile app on iOS or Android.';

    return { isUploaded: !!isUploaded, isVerified, isComplete, canInteract, message };
  }, [userDetails]);

  // check(): returns { allowed: boolean, reason: string }
  const check = () => {
    if (result.canInteract) return { allowed: true };
    return { allowed: false, reason: result.message };
  };

  return { ...result, check };
}
